module.exports = __webpack_public_path__ + "static/media/RocksonLiu@2x.2318344a.png";